export default {
  methods: {
    async getImg (img) {
      // console.log(img)
      img.loading = true
      let path = img.url
      this.$set(img, 'src', 'https://smaco2.uestc.edu.cn/passApi' + path)
      img.loading = false
    }
  }
}
